import Cookies from 'js-cookie'

export default function({ query }) {
  const { ref } = query

  if (!ref) return

  const exptime = Date.now() + 1000 * 86500 * 30
  const expires = new Date(exptime)

  Cookies.set('ref', ref, { expires: expires })
}
